<template>
  <div class="filterItem">
    <span class="filterItem_text">{{ title }}:</span>
    <div v-if="isQuantity">
      <input ref="input" hidden type="number" :value="weeks" />
      <div class="quantity filterItem_body">
        <span class="quantity_text">{{ weeks }}</span>
        <div class="quantityBtn">
          <svg-sprite
              width="20"
              height="20"
              icon-id="arrowDropDown"
          ></svg-sprite>
          <button @click="onCount('plus')" class="rotate-180 plus"></button>
          <button class="minus" @click="onCount('minus')"></button>
        </div>
      </div>
    </div>
    <v-menu v-else bottom :close-on-content-click="false" v-model="menu">
      <template v-slot:activator="{ on, attrs }">
        <div class="filterItem_body" v-bind="attrs" v-on="on">
          <span class="mr">{{ currentDate }}</span>
          <svg-sprite width="20" height="20" icon-id="date"></svg-sprite>
        </div>
      </template>

      <div class="filterItem_dropDown">
        <field
          margin="0 0 10px"
          width="300px"
          placeholder="Select type"
          @updateSelect="onSelect"
          :autocompleteValue="type"
          :items="filterItems"
          is-select
          :is-clearable="false"
        ></field>
        <field
          margin="0 0 20px"
          width="300px"
          type="text"
          label="Date"
          placeholder="Enter date"
          :dateValue="date"
          @updateDate="onDate"
          is-date
          is-no-title
        ></field>
        <div class="filterItem_dropDown-btn">
          <button @click="onApply">OK</button>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
import getDefaultDate from "@/helper/getDefaultDate";
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash.debounce";

export default {
	name: "FilterItem",
	props: {
		title: String,
		isQuantity: Boolean,
	},
	computed: mapGetters([ 'disType', 'disDate', 'disWeeks', 'isRefreshData' ]),
	watch: {
		menu(val) {
			if (!val) {
				this.date = this.currentDate;
				this.type = this.currentType;
			}
		},
		isRefreshData(val, oldVal) {
			if (val !== oldVal) {
				this.onInit();
			}
		}
	},
	data: () => ({
		currentDate: getDefaultDate(),
		menu: false,
		type: 'Delivery',
		weeks: '',
		currentType: 'Delivery',
		date: getDefaultDate(),
		filterItems: [ { value: 'Delivery' }, { value: 'PickUP' } ]
	}),
	methods: {
		...mapActions([ 'onDataChange' ]),
		onSelect({ value }) {
			this.type = value;
		},
		onDate(value) {
			this.date = value;
		},
		onCount(key) {
			const { input } = this.$refs;
			if (key === "plus") {
				input.value >= 10 ? input.value : input.value++;
			} else {
				input.value <= 1 ? input.value : input.value--;
			}
   
			this.weeks = input.value;
   
			this.onDelayChange(input.value);
		},
		onDelayChange: debounce(function(weeks) {
			this.onDataChange({ weeks });
		}, 600),
		onApply() {
			this.currentDate = this.date;
			this.currentType = this.type;
			this.onDataChange({ type: this.type, date: this.date });
			this.menu = false;
		},
		onInit() {
			const { input } = this.$refs;
			if (input) input.value = this.disWeeks;
			this.type = this.disType;
			this.date = this.disDate;
			this.currentDate = this.disDate;
			this.weeks = this.disWeeks;
		}
	},
	mounted() {
		this.onInit();
	},
};
</script>

<style scoped lang="scss">
@import "filterItem";
</style>
